import { Status } from "@common/models";
import { Field } from "./field";
import { Section } from "./section";

export class SectionFieldId {
  section: Section;
  field: Field;
}

export class SectionField {
  id: SectionFieldId = new SectionFieldId();
  status: Status = new Status();
}
